module.exports = __webpack_public_path__ + "static/media/MengYunLee_cv.499e372b.pdf";